import { render } from "./TermsThirdParties.vue?vue&type=template&id=18a5b0d0"
import script from "./TermsThirdParties.vue?vue&type=script&lang=js"
export * from "./TermsThirdParties.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__